/**
 * useOnlineDetection — Reactive online/offline state.
 *
 * Subscribes to window online/offline events. Initial value from navigator.onLine.
 */
import { useState, useEffect } from 'react';

export function useOnlineDetection() {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return { isOnline };
}
